// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_ZzJ","cls2":"VideoPlayerMainContent-cls2_iFf VideoPlayerMainContent-cls1_ZzJ"};